
import { Component, Vue } from "vue-property-decorator";
import { cloneDeep } from "lodash";
import Pagination from "@/components/Pagination/index.vue";
import { ISupplierModel, SupplierProductModel } from "@/api/types";
import {
  createSupplier,
  defaultSupplierData,
  deleteSupplier, downloadAllInfo,
  getSuppliers,
  updateSupplier,
  uploadSuppliers,
} from "@/api/supplier";
import { Form, Row } from "element-ui";
import Template from "@/views/system-management/template/index.vue";
import { recordHqPackingListAccountingPeriod } from "@/api/hq-packing-list";

@Component({
  name: "SupplierManagement",
  components: {
    Template,
    Pagination,
  },
})
export default class extends Vue {
  private tableKey = 0;
  private suppliers: ISupplierModel[] = [];
  private supplierProducts: SupplierProductModel[] = [];
  private total = 0;
  private listLoading = true;
  private dialogFormVisible = false;
  private popoverVisible = false;
  private dialogStatus = "";
  private textMap = {
    update: "编辑",
    create: "新增",
  };
  private showFileList = false;
  private dialogPageViewsVisible = false;
  private supplierProductVisible = false;
  private pageViewsData = [];
  private payload = new WriteSupplierInput();
  private files: File[] = [];
  private rules = {
    code: [{ required: true, message: "编号不能为空", trigger: "blur" }],
    name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
    abbreviation: [
      { required: true, message: "简称不能为空", trigger: "blur" },
    ],
    address: [{ required: true, message: "货源地不能为空", trigger: "blur" }],
    purchaser: [{ required: true, message: "采购员不能为空", trigger: "blur" }],
    accountant: [
      { required: true, message: "应付会计不能为空", trigger: "blur" },
    ],
  };
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    keywords: null,
  };
  private uploadType = "";

  created() {
    this.getList();
  }

  private async getList() {
    this.listLoading = true;
    const params = Object.assign({}, this.listQuery);
    const { total, content }: any = await getSuppliers(params);
    this.total = total;
    this.suppliers = content;
    this.suppliers.forEach(item => {
      item.popoverVisible = false;
    })
    console.log('this.suppliers',this.suppliers)
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  private deleteMe(id) {
    // this.suppliers.find(e => e.id === id).popoverVisible = !this.suppliers.find(e => e.id === id).popoverVisible;
    this.$set(this.suppliers,this.suppliers.findIndex(e => e.id === id),{
      ...this.suppliers.find(e => e.id === id),
      popoverVisible: !this.suppliers.find(e => e.id === id).popoverVisible
    })
    this.$forceUpdate();
    console.log('this.suppliers',this.suppliers)
  }

  private async clickSubmit(type: string) {
    this.uploadType = type;
    this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
  }

  private handleFilter() {
    this.listQuery.pageNumber = 1;
    this.getList();
  }

  private async recordHqPackingListAccountingPeriod() {
    this.$notify({
      title: "成功",
      message: "开始记录账期",
      type: "success",
      duration: 2000,
    });
    await recordHqPackingListAccountingPeriod();
    this.$notify({
      title: "成功",
      message: "记录完成",
      type: "success",
      duration: 2000,
    });
  }

  private resetEmptyData() {
    this.payload = cloneDeep(defaultSupplierData);
  }

  private async queryProduct(supplierProducts: SupplierProductModel[]) {
    this.supplierProducts = supplierProducts;
    this.supplierProductVisible = true;
  }

  private handleCreate() {
    this.resetEmptyData();
    this.dialogStatus = "create";
    this.dialogFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  private onUpdate(row: ISupplierModel) {
    this.payload = Object.assign({}, row);
    if (this.payload.supplierProducts == null) {
      this.payload.supplierProducts = [];
    }
    if (this.payload.supplierProducts) {
      this.payload.supplierProducts.forEach(item => {
        if (item.special) {
          item.declarationDescription = "*" + item.declarationDescription;
        }
      });
    }
    this.dialogStatus = "update";
    this.dialogFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  private async onDelete(row: ISupplierModel) {
    await deleteSupplier(row.id);
    this.dialogFormVisible = false;
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private async createData() {
    (this.$refs.dataForm as Form).validate(async (valid) => {
      if (valid) {
        await createSupplier({
          code: this.payload.code,
          name: this.payload.name,
          address: this.payload.address,
        });
        this.dialogFormVisible = false;
        this.$notify({
          title: "成功",
          message: "创建成功",
          type: "success",
          duration: 2000,
        });
        await this.getList();
      }
    });
  }

  private addSpecialCharge(supplierProducts: SupplierProductModel[]) {
    const c = new SupplierProductModel();
    supplierProducts.push(c);
  }

  private updateData() {
    (this.$refs.dataForm as Form).validate(async (valid) => {
      if (valid) {
        await updateSupplier(this.payload.id, {
          name: this.payload.name,
          code: this.payload.code,
          abbreviation: this.payload.abbreviation,
          generalCode: this.payload.generalCode,
          generalAbbreviation: this.payload.generalAbbreviation,
          address: this.payload.address,
          purchaser: this.payload.purchaser,
          accountant: this.payload.accountant,
          marker: this.payload.marker,
          orderAuditor: this.payload.orderAuditor,
          payment: this.payload.payment,
          accountPeriod: this.payload.accountPeriod,
          depositPercent: this.payload.depositPercent,
          longTermDeposit: this.payload.longTermDeposit,
          supplierProducts: this.payload.supplierProducts,
          locked: this.payload.locked
        });
        this.dialogFormVisible = false;
        this.$notify({
          title: "成功",
          message: "更新成功",
          type: "success",
          duration: 2000,
        });
        await this.getList();
      }
    });
  }

  private gotoInforCardMT(row) {
    console.log("点击跳转", row);
    this.$router.push(`/information-card-management`);
  }

  private async cancelEdit() {
    this.dialogFormVisible = false;
    await this.getList();
  }

  private addFile(file: File) {
    if (file.size / 1024 / 1024 >= 100) {
      this.$message({
        message: "上传的文件大小不能超过100M!",
        type: "error",
      });
    }
    this.files.push(file);
  }

  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    formData.append("type", this.uploadType);
    await uploadSuppliers(formData);
    await this.getList();
  }

  private specialProduct({row,rowIndex}) {
    if (row.special) {
      return 'error-row'
    }
    return ''
  }

  private downloadAllInfoLoading = false;

  private async downloadAllInfo() {
    this.downloadAllInfoLoading = true;
    try {
      await downloadAllInfo();
    }  finally {
      this.downloadAllInfoLoading = false;
    }
  }
}

class WriteSupplierInput {
  id: string;
  code: string;
  name: string;
  abbreviation: string;
  generalCode: string;
  generalAbbreviation: string;
  address: string;
  purchaser: string;
  accountant: string;
  marker: string;
  orderAuditor: string;
  payment: string;
  accountPeriod: string;
  depositPercent: string;
  longTermDeposit: string;
  locked?: boolean;
  supplierProducts: SupplierProductModel[];

  constructor(
    id?: string,
    code?: string,
    name?: string,
    abbreviation?: string,
    generalCode?: string,
    generalAbbreviation?: string,
    address?: string,
    purchaser?: string,
    accountant?: string,
    marker?: string,
    orderAuditor?: string,
    payment?: string,
    accountPeriod?: string,
    depositPercent?: string,
    longTermDeposit?: string,
    supplierProducts?: SupplierProductModel[]
  ) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.abbreviation = abbreviation;
    this.generalCode = generalCode;
    this.generalAbbreviation = generalAbbreviation;
    this.address = address;
    this.purchaser = purchaser;
    this.accountant = accountant;
    this.marker = marker;
    this.orderAuditor = orderAuditor;
    this.payment = payment;
    this.accountPeriod = accountPeriod;
    this.depositPercent = depositPercent;
    this.longTermDeposit = longTermDeposit;
    this.supplierProducts = supplierProducts;
  }
}
